// extracted by mini-css-extract-plugin
export default {"headerNavBack":"ModifiersHeader-module__headerNavBack___29YfG"};